// extracted by mini-css-extract-plugin
export default {"cprimary":"#73b0f4","cblue":"#73b0f4","cbrandblue":"#4fc1d1","cgray":"#b6b6b6","clightgray":"#d2d2d2"};